import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Select } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { SEARCH_TYPES } from '../../config/searchConfig';

const SEPARATOR = '::';
const toKey = ({ type, term }) => `${type}${SEPARATOR}${term}`;
const fromKey = (key) => {
  const index = key.indexOf(SEPARATOR);
  return {
    type: key.slice(0, index),
    term: key.slice(index + SEPARATOR.length),
  };
};
const toLabel = ({ type, term }) =>
  `${SEARCH_TYPES[type]?.label || type}: ${term}`;

// Jedno polje "Pretraga": kucanjem se nude opcije po tipu ("LBO: 123", ...),
// a izabrane pretrage ostaju kao chipovi (jedan po tipu). Tipovi za stranicu
// dolaze iz src/config/searchConfig.js preko useTableSearch.
const TableSearch = ({ types, entries, onChange }) => {
  const [text, setText] = useState('');
  // Lista se zatvara posle izbora (multiple Select je inace drzi otvorenom);
  // sledece kucanje je ponovo otvara.
  const [open, setOpen] = useState(false);
  const term = text.trim();

  const options = term
    ? types
        .filter(
          (type) => !type.digitsOnly || term.replace(/\D/g, '').length > 0
        )
        .map((type) => {
          const entry = {
            type: type.key,
            term: type.digitsOnly ? term.replace(/\D/g, '') : term,
          };
          return { value: toKey(entry), label: toLabel(entry) };
        })
    : [];

  const handleChange = (selected) => {
    // Novi izbor za isti tip zamenjuje prethodni chip tog tipa.
    const byType = new Map();
    selected.forEach(({ value }) => {
      const entry = fromKey(value);
      byType.delete(entry.type);
      byType.set(entry.type, entry);
    });
    onChange([...byType.values()]);
    setText('');
    setOpen(false);
  };

  return (
    <Select
      mode="multiple"
      className="table-search"
      labelInValue
      value={entries.map((entry) => ({
        value: toKey(entry),
        label: toLabel(entry),
      }))}
      options={options}
      onChange={handleChange}
      open={open}
      onOpenChange={setOpen}
      showSearch={{
        searchValue: text,
        onSearch: setText,
        filterOption: false,
        autoClearSearchValue: true,
      }}
      prefix={<SearchOutlined />}
      suffixIcon={null}
      placeholder="Pretraga"
      notFoundContent={null}
      maxTagCount="responsive"
      allowClear
    />
  );
};

TableSearch.propTypes = {
  types: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      digitsOnly: PropTypes.bool,
    })
  ).isRequired,
  entries: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string.isRequired,
      term: PropTypes.string.isRequired,
    })
  ).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default TableSearch;
